import React from 'react';
import useAnnulerRideApi from '../../../apis/ride/hooks/useAnnulerRideApi';
import useGetAllRides from '../../../apis/ride/hooks/useGetAllRides';
import Btn from '../../../components/button/Btn';
import Button from '../../../components/button/Button';
import Notification from '../../../components/notification/Notification';
import useAuthContext from '../../../context/authContext/useAuthContext';
import useRidesContext from '../../../context/ridesContext/useRidesContext';

function ModalCancel({ isCancelModalOpen, setIsCancelModalOpen, rideId }) {
    const { user } = useAuthContext();
    const { setRides } = useRidesContext();
    const { request: getRides } = useGetAllRides();

    const { request: annuler } = useAnnulerRideApi();

    const closeNotification = () => {
        setIsCancelModalOpen(false);
    };

    const handleCancel = () => {
        const request = {
            token: user.token,
            id: rideId,
        };
        annuler(request)
            .then(() => {
                getRides({ token: user.token }).then((response) => {
                    if (response && response.data) {
                        setRides(response.data);
                    }
                });
                setIsCancelModalOpen(false);
            })
            .catch((err) => console.error(err));
    };

    if (!isCancelModalOpen) {
        return null;
    }

    return (
        <Notification bgOnClick={closeNotification}>
            <p>Souhaitez-vous vraiment annuler la course ?</p>
            <Button status='error' onClick={handleCancel}>
                Annuler
            </Button>
            <Btn onClick={closeNotification}>Fermer</Btn>
        </Notification>
    );
}

export default ModalCancel;
